<template>
  <v-container>
    <ValidationObserver ref="form">
      <FormToolbar
        :title="edit ? 'Edit Client' : 'New Client'"
        :onSubmitClick="submitForm"
        :onCloseClick="onCloseClick"
        :disableSubmitValue="false"
      />
      <v-form class="mt-1" @keyup.enter.native="submitForm">
        <v-container>
          <v-row>
            <v-col cols="12" lg="4">
              <ValidationProvider
                name="Client Name"
                rules="required|max:50"
                v-slot="{ errors }"
              >
                <v-text-field
                  ref="firstInput"
                  type="text"
                  v-model="entity.name"
                  :error-messages="errors"
                  label="Client Name"
                  :counter="50"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-col cols="12">
            <v-checkbox
              v-if="edit"
              v-model="entity.isActive"
              label="Active"
            ></v-checkbox>
          </v-col>
        </v-container>
        <v-text-field class="hidden"> </v-text-field>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import FormToolbar from '../ui/FormToolbar.vue';
import '../../validators';

export default {
  props: {
    edit: Boolean,
    entity: Object,
    onSubmitClick: Function,
    onCloseClick: Function,
    bus: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    FormToolbar,
  },
  mounted() {
    this.bus.$on('resetForm', this.resetForm);
  },
  methods: {
    submitForm() {
      this.$refs.form.validate()
        .then((isValid) => {
          if (isValid) this.onSubmitClick();
        });
    },
    resetForm() {
      this.$nextTick(() => this.$refs.firstInput.focus());
      this.$refs.form.reset();
    },
  },
};
</script>
